import * as React    from "react";
import { l10nError } from "../../helpers/l10nErrors";
// import MenuList      from "./components/MenuList";
// import MenuPortal    from "./components/MenuPortal";

export const loadingMessage = () => 'Загрузка';

export const noOptionsMessage = () => 'Ничего не найдено';
const errorMessage = (error: string) => () => <span className="text-danger">{l10nError(error)}</span>;
// export const getNoOptionsMessage = (props) => props.error
//   ? errorMessage(props.error)
//   : noOptionsMessage;

export const height = 36;

// const componentsForBigList = { MenuList, MenuPortal };
// const componentsForSmallList = { MenuPortal };
// export const getComponents = (props) => Array.isArray(props.options) && props.options.length > 50
//   ? componentsForBigList
//   : componentsForSmallList;
